import { Guid, Nillable } from '@web/utils';

export class DictionaryCollectionItem {
  public constructor(
    private readonly _data: {
      canBeEdited: boolean;
      canBeRemoved: boolean;
      createdAt: Date;
      id: Guid;
      label: string;
      position: number;
      slug?: Nillable<string>;
    },
  ) {}

  public get id(): Guid {
    return this._data.id;
  }

  public get position(): number {
    return this._data.position;
  }

  public get label(): string {
    return this._data.label;
  }

  public get slug(): Nillable<string> {
    return this._data.slug;
  }

  public get createdAt(): Date {
    return this._data.createdAt;
  }

  public get canBeRemoved(): boolean {
    return this._data.canBeRemoved;
  }

  public get canBeEdited(): boolean {
    return this._data.canBeEdited;
  }
}
